import ExcelGrid from "components/Custom/ExcelGrid";
import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/lables";
import React, { useEffect, useRef, useState } from "react";
import Loader from "components/Custom/Loader";
import Btn from "components/Custom/Btn";
import { COLORS } from "common/colors";
import { TRANS_APIs } from "apihandlers/transaction";
import { FORMATS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";
import { DateFunctions } from "common/datefunctions";
import {ORDER_APIs} from "apihandlers/order"


const ItemReturn = (props: any) => {
  const {
    salesInvoiceRef,
    selectedRow,
    setManageReturnDialog,
    setSelectedRow,
    reloadGrid,
  } = props;
  const returnRef: any = useRef();
  const [returnRows, setReturnRows] = useState<any[]>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const formulaRenderer = (row) => {
    console.log("formulaRenderer: ", row);
    let quantity = Number(row["soldQty"] || 0);
    let sold = Number(row["soldSku"] || 0);
    let price = Number(row["price"] || 0);
    let taxStructure = row["orderItemTaxAmount"];
    console.log("taxStructure", taxStructure);
    let basic = 0;
    let taxAmount = 0;
    let cgst = 0;
    let sgst = 0;
    let total = 0;
    if (!isNaN(quantity) && !isNaN(price)) {
      basic = Number(price * quantity);
      taxAmount = (taxStructure / sold) * quantity;
      cgst = Number((taxAmount / 2).toFixed(2));
      sgst = Number((taxAmount / 2).toFixed(2));
      total = Number(basic + taxAmount);
    }
    row["basic"] = basic;
    row["taxAmount"] = taxAmount;
    row["total"] = total;
    row["cgst"] = cgst;
    row["sgst"] = sgst;
    const summary = returnRef.getSummary();
    //  setTotalQty(Number(summary[0].soldQty.replace("Total: ", "")));
    return row;
  };

  const returnCols = [
    {
      key: "productName",
      type: "text",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.PRODUCT_NAME,
      width: "30%",
    },
    {
      key: "soldSku",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.SOLD_SKU,
      width: "10%",
    },
    {
      key: "soldQty",
      type: "number",
      editable: true,
      sortable: false,
      searchable: false,
      name: LABELS.QTY,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "price",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.RATE,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "basic",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.BASIC_RATE,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "cgst",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.CGST_AMOUNT,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "sgst",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.SGST_AMOUNT,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
    {
      key: "total",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.AMOUNT,
      width: "10%",
      renderSum: true,
      formula: formulaRenderer,
    },
  ];
  useEffect(() => {
    getReturnRows();
  }, []);

  const getReturnRows = () => {
    console.log("selectedItem", selectedRow.items);
    let items = [selectedRow.items];
    console.log("items", items);
    const listItem = items[0].map((q) => {
      return {
        productId: q.productSkuId,
        productName: q.productName,
        soldSku: q.soldSku,
        soldSkuDup: q.soldSkuDup,
        price: q.price,
        orderItemTaxAmount: q.orderItemTaxAmount,
        orderItemTotal: q.orderItemTotal,
      };
    });
    setReturnRows(listItem);
    return listItem;
  };
  console.log("listItem", returnRows);
  const manageReturn = () => {
    // let gridRows = returnRef.getRowData();
    // console.log("gridRows", gridRows);
    // let gridRowsJson = {};
    // for (let i = 0; i < gridRows.length; i++) {
    //   const row = gridRows[i];
    //   const orderId = row.orderId;
    //   if (!gridRowsJson[orderId]) {
    //     gridRowsJson[orderId] = [];
    //   }
    //   gridRowsJson[orderId].push({
    //     orderId: row.orderId,
    //     orderItemId: -1,
    //     productSkuId: row.productSkuId,
    //     soldSku: row.soldSku,
    //     invoiceSku: row.soldSkuDup,
    //   });
    // }
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    const itemsRows = returnRef.getRowData();
    const summary = returnRef.getSummary();
    console.log("itemsRows", itemsRows);

    const args = {
      orderId: -1,
      customerId: selectedRow.customerId,
      areaId: selectedRow.areaId,
      status: 5,
      remarks,
      isInvoice: "false",
      isReturn: "true",
      isSale: "true",
      total: Number(Number(summary[0].total.replace("Total:", "")).toFixed(2)),
      basic: Number(Number(summary[0].basic.replace("Total:", "")).toFixed(2)),
      cgstAmount: Number(
        Number(summary[0].cgst.replace("Total:", "")).toFixed(2)
      ),
      sgstAmount: Number(
        Number(summary[0].sgst.replace("Total:", "")).toFixed(2)
      ),
      taxAmount: Number(
        (
          Number(summary[0].cgst.replace("Total:", "")) +
          Number(summary[0].sgst.replace("Total:", ""))
        ).toFixed(2)
      ),

      items: itemsRows.map((item) => {
        return {
          orderItemId: -1,
          productSkuId: item.productId,
          soldSku: Number(item.soldQty),
          price: item.price,
          orderItemBasic: Number(item.basic),
          itemcgstAmount: Number(item.taxAmount / 2),
          itemsgstAmount: Number(item.taxAmount / 2),
          orderItemTaxAmount: Number(item.taxAmount),
          orderItemTotal: Number(item.total),
        };
      }),
    };
    let errors = [];
    for (let i = 0; i < itemsRows.length; i++) {
      if (Number(itemsRows[i].soldQty) > itemsRows[i].soldSku) {
        errors.push({
          id: "item",
          msg:
            "You can select maximum upto " +
            "<span class='bold'>" +
            itemsRows[i].soldSku +
            "</span> " +
            " items for " +
            "<span class='bold'>" +
            itemsRows[i].productName,
        });
      }
    }
    if (remarks === "") {
      errors.push({
        id: "remarks",
        msg:
          "<span class='bold'>" +
          LABELS.REMARKS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    console.log("gridRowsargs", args);

    ORDER_APIs.manageOrder(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageReturnDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("returnRows", returnRows);

  return (
    <>
      {returnRows != null && (
        <>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.PARTY_NAME}
                defaultValue={selectedRow.customerName}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.BILL_NO}
                defaultValue={
                  selectedRow.invoiceNumber
                    ? selectedRow.invoiceNumber
                    : selectedRow.orderNumber
                }
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.BILL_DATE}
                defaultValue={selectedRow.orderDate}
                disabled={true}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.ADDRESS}
                defaultValue={selectedRow.address}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.PHONE}
                defaultValue={selectedRow.customerMobileNumber}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.GST_IN}
                defaultValue={selectedRow.gstIn}
                disabled={true}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.NUMBER_OF_QUANTITY_RETURN}
                value={""}
                defaultValue={""}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.SALES_RETURN_NO}
                defaultValue={selectedRow.salesNo}
                disabled={true}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.SALES_RETURN_DATE}
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  FORMATS.SQL_DATE_ONLY
                )}
                disabled={true}
              />
            </div>
          </div>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                id={"remarks"}
                label={LABELS.COMMENTS}
                required={true}
                type={"text"}
                disabled={false}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30"></div>
          </div>

          <ExcelGrid
            id={"returnGrid"}
            childRef={returnRef}
            cols={returnCols}
            rows={returnRows}
            noTotalRows={true}
          />
          <div style={{ margin: "1rem 1rem 1rem 0rem" }}>
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "right",
              width: "99%",
            }}
          >
            <div
              style={{
                width: "35%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <Btn
                text={LABELS.CANCEL}
                onClick={() => {
                  setManageReturnDialog(false);
                }}
                marginRight={15}
                color={COLORS.RELOAD_EXPORT_TEXT}
                bgColor={COLORS.RELOAD_EXPORT}
                //  loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                onClick={manageReturn}
                marginRight={15}
                bgColor={COLORS.GRID_ADD_NEW}
                //  loading={isSubmit}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default ItemReturn;
